/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteAppointments = gql`
  mutation DeleteAppointments($ids: [ID!]!) {
    deleteAppointments(ids: $ids)
  }
`;
